import { SetStateAction, useEffect, useState } from "react";

export const useClientHeight = (
  ref: {
    current: { clientHeight: SetStateAction<number>; clientWidth: any } | null;
  },
  deps: any[] = []
) => {
  const [divHeight, setDivHeight] = useState(0);
  useEffect(() => {
    setDivHeight(ref.current?.clientHeight || 0);
  }, [ref, ref.current?.clientHeight, ...deps]);
  return divHeight;
};
export const useToggle = (initialValue: boolean): [boolean, () => void] => {
  const [toggle, _setToggle] = useState(initialValue);
  const setToggle = () => {
    _setToggle(!toggle);
  };
  return [toggle, setToggle];
};
